import { useAuth } from '@/app/AuthHook';
import React, { ReactNode, useCallback } from 'react';

import styles from './styles.module.scss';
import headerStyles from '../../styles.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { t } from 'i18next';
import { useAuthSelectors } from '@app/useAuthSelectors';
import { authServiceLogout } from '@/api';
import { getVersionedUrl } from '@shared/lib/getVersionedUrl';

type Props = {
    setTooltipContent: (p: ReactNode) => void;
};

export const UserButtons: React.FC<Props> = ({ setTooltipContent }) => {
    const { user, setUser } = useAuth();

    const { isAdmin } = useAuthSelectors();

    const navigate = useNavigate();

    const handleLogout = useCallback(() => {
        authServiceLogout()
            .then((resp) => {
                if (resp?.error) {
                    alert(t('logoutError'));
                    return;
                }
                setUser && setUser(null);
            })
            .catch(() => alert(t('logoutError')));
    }, [setUser]);

    const handleGoToProfile = useCallback(() => navigate('/user'), [navigate]);

    const handleGoToAdminPanel = useCallback(() => navigate('/admin'), [navigate]);

    const handleMouseEnter = useCallback(
        () =>
            setTooltipContent(
                <div className={headerStyles.tooltipContent}>
                    {isAdmin && (
                        <span onClick={handleGoToAdminPanel} className={styles.dropdown_item}>
                            {t('menuAdmin')}
                        </span>
                    )}
                    <span onClick={handleGoToProfile} className={styles.dropdown_item}>
                        {t('userProfile')}
                    </span>
                    <span onClick={handleLogout} className={styles.dropdown_item} data-testid="logout">
                        {t('logout')}
                    </span>
                </div>
            ),
        [setTooltipContent, handleGoToProfile, handleLogout, handleGoToAdminPanel, isAdmin]
    );

    return user?.ID ? (
        <div
            className={styles.avatar}
            data-tooltip-id="header-end-tooltip"
            data-tooltip-class-name={styles.tooltip}
            data-tooltip-place="bottom-end"
            onMouseEnter={handleMouseEnter}
        >
            {user.Avatar ? (
                <img
                    className={styles.avatar__img}
                    src={getVersionedUrl(user.Avatar, user.AvatarRevision)}
                    alt="avatar"
                />
            ) : (
                <div className={styles.avatar__empty} />
            )}
        </div>
    ) : (
        <Link to="/sign-in" className={styles.signIn}>
            <Trans i18nKey="menuSignIn" />
        </Link>
    );
};
